import React from 'react';
import {
    Home,
    Kanban,
    BarChart3,
    User,
    LogOut,
    Menu,
    MessageCircle,
    MessageSquare,
    Minus,
    Mail,
    Users,
    CreditCard,
    Ban,
    Settings,
    Code,
    Plus,
    Filter,
    Search,
    X,
    MoreHorizontal,
    Copy,
    Info,
    Pencil,
    Trash2,
    CheckCircle,
    Check,
    Calendar,
    Download,
    Upload,
    RefreshCw,
    DollarSign,
    BookOpen,
    IdCard,
    Clock,
    ArrowRight,
    ArrowLeft,
    Box,
    MapPin,
    Camera,
    Image,
    Video,
    Lock,
    Bell,
    ShieldCheck,
    ChevronDown,
    ChevronUp,
    ChevronLeft,
    ChevronRight,
    ChevronsLeft,
    ChevronsRight,
    ClipboardCheck,
    Files,
    Key,
    AlertCircle,
    ClipboardList,
    CircleUser,
    Smartphone,
    PlusCircle,
    CheckSquare,
    AlertTriangle,
    Activity,
    Briefcase,
    Building,
    FileText,
    Loader2,
    Unlink,
    Link,
    Tag,
    XCircle,
    Phone,
    Handshake,
    Package,
    ShoppingCart,
    GripVertical,
    Flag,
    Webhook,
    ThumbsDown,
    Mic,
    Pause,
    Send,
    Archive,
    ArchiveRestore,
    ArrowUp,
    ArrowDown,
    ArrowUpDown,
    UserX,
    ClipboardX,
    AlarmClock,
    Smile,
    SlidersHorizontal,
    CornerUpLeft,
    MessageSquarePlus,
    Star,
    Zap,
    Eye,
    EyeOff,
    Play,
    Sparkles,
    LifeBuoy,
    Headset,
    Gift,
    Wallet,
} from 'lucide-react';
import { WhatsAppIcon, FacebookIcon, PixIcon, PixLineIcon } from './CustomIcons';

export const iconMap = {
    // Brand
    whatsapp: WhatsAppIcon,
    pix: PixIcon,
    'pix-line': PixLineIcon,
    facebook: FacebookIcon,

    // Navigation & layout
    home: Home,
    kanban: Kanban,
    pipeline: Kanban,
    chart: BarChart3,
    user: User,
    logout: LogOut,
    menu: Menu,

    // Communication
    message: MessageCircle,
    chat: MessageSquare,
    mail: Mail,
    phone: Phone,
    headset: Headset,
    mic: Mic,
    smile: Smile,
    'message-plus': MessageSquarePlus,
    'corner-up-left': CornerUpLeft,

    // Entities
    users: Users,
    'credit-card': CreditCard,
    product: Box,
    task: ClipboardCheck,
    package: Package,
    'shopping-cart': ShoppingCart,
    handshake: Handshake,
    building: Building,
    briefcase: Briefcase,
    tag: Tag,
    flag: Flag,
    webhook: Webhook,

    // Actions
    settings: Settings,
    code: Code,
    plus: Plus,
    'plus-circle': PlusCircle,
    filter: Filter,
    sliders: SlidersHorizontal,
    search: Search,
    close: X,
    x: X,
    more: MoreHorizontal,
    copy: Copy,
    edit: Pencil,
    trash: Trash2,
    download: Download,
    upload: Upload,
    refresh: RefreshCw,
    duplicate: Files,
    send: Send,
    pause: Pause,
    play: Play,
    link: Link,
    unlink: Unlink,
    archive: Archive,
    'archive-restore': ArchiveRestore,
    'grip-vertical': GripVertical,

    // Status & indicators
    info: Info,
    'check-circle': CheckCircle,
    'check-square': CheckSquare,
    check: Check,
    minus: Minus,
    ban: Ban,
    alert: AlertCircle,
    'alert-triangle': AlertTriangle,
    'x-circle': XCircle,
    lock: Lock,
    bell: Bell,
    shield: ShieldCheck,
    clock: Clock,
    'alarm-clock': AlarmClock,
    loader: Loader2,
    activity: Activity,
    'thumbs-down': ThumbsDown,
    zap: Zap,
    sparkles: Sparkles,
    'life-buoy': LifeBuoy,
    star: Star,
    'star-filled': Star,
    eye: Eye,
    'eye-off': EyeOff,

    // Arrows & chevrons
    'arrow-left': ArrowLeft,
    'arrow-right': ArrowRight,
    'arrow-up': ArrowUp,
    'arrow-down': ArrowDown,
    'arrow-up-down': ArrowUpDown,
    'chevron-down': ChevronDown,
    'chevron-up': ChevronUp,
    'chevron-left': ChevronLeft,
    'chevron-right': ChevronRight,
    'chevron-double-left': ChevronsLeft,
    'chevron-double-right': ChevronsRight,

    // Features / content
    calendar: Calendar,
    dollar: DollarSign,
    gift: Gift,
    wallet: Wallet,
    book: BookOpen,
    id: IdCard,
    location: MapPin,
    camera: Camera,
    image: Image,
    video: Video,
    key: Key,
    'clipboard-doc': ClipboardList,
    'clipboard-x': ClipboardX,
    'file-text': FileText,
    avatar: CircleUser,
    tracking: Code,
    smartphone: Smartphone,
    'user-x': UserX,
} as const;

export type IconName = keyof typeof iconMap;

interface AppIconProps extends Omit<React.SVGProps<SVGSVGElement>, 'name'> {
    name: IconName;
}

export const AppIcon: React.FC<AppIconProps> = ({ name, className, ...props }) => {
    const IconComponent = iconMap[name];
    if (!IconComponent) {
        console.warn(`Icon "${name}" not found in iconMap.`);
        return null;
    }

    return (
        <IconComponent
            className={className || 'w-5 h-5'}
            aria-hidden="true"
            {...(props as React.ComponentProps<typeof IconComponent>)}
        />
    );
};
